export const sounds = [
    {
        letter: "s",
        sound: "s",
        icon: "sun"
    },
    {
        letter: "a",
        sound: "a",
        icon: "ant"
    },
    {
        letter: "t",
        sound: "t",
        icon: "tap"
    },
    {
        letter: "p",
        sound: "p",
        icon: "penguin"
    },
    {
        letter: "i",
        sound: "i",
        icon: "igloo"
    },
    {
        letter: "n",
        sound: "n",
        icon: "net"
    },
    {
        letter: "m",
        sound: "m",
        icon: "map"
    },
    {
        letter: "d",
        sound: "d",
        icon: "dog"
    },
    {
        letter: "g",
        sound: "g",
        icon: "guitar"
    },
    {
        letter: "o",
        sound: "o",
        icon: "octopus"
    },
    {
        letter: "c",
        sound: "c",
        icon: "cat"
    },
    {
        letter: "k",
        sound: "c",
        icon: "king"
    },
    {
        letter: "ck",
        sound: "c",
        icon: "duck"
    },
    {
        letter: "e",
        sound: "e",
        icon: "egg"
    },
    {
        letter: "u",
        sound: "u",
        icon: "umbrella"
    },
    {
        letter: "r",
        sound: "r",
        icon: "rat"
    },
    {
        letter: "h",
        sound: "h",
        icon: "hat"
    },
    {
        letter: "b",
        sound: "b",
        icon: "bin"
    },
    {
        letter: "f",
        sound: "f",
        icon: "frog"
    },
    {
        letter: "ff",
        sound: "f",
        icon: "muffin"
    },
    {
        letter: "l",
        sound: "l",
        icon: "leaf"
    },
    {
        letter: "ll",
        sound: "l",
        icon: "bell"
    },
    {
        letter: "ss",
        sound: "s",
        icon: "dress"
    }
]